import { ActivityReducer } from "reducers/activityReducer"
import { localeTexts } from "locale/texts"

export interface User {
  id?: string
  name: string
  eventList: any[]
}

export interface Activity extends ActivityReducer {
}
export enum ProfileType {
  Dancer = "Dancer",
  Performer = "Performer",
  Teacher = "Teacher",
  Organiser = "Organiser",
  Musician = "Musician"
}

export const getProfileName = (profileType: ProfileType) => {
  switch (profileType) {
    case ProfileType.Dancer:
      return localeTexts.profile.dancer
    case ProfileType.Performer:
      return localeTexts.profile.performer
    case ProfileType.Teacher:
      return localeTexts.profile.teacher
    case ProfileType.Organiser:
      return localeTexts.profile.organiser
    case ProfileType.Musician:
      return localeTexts.profile.musician
    default:
      return ""
  }
}

export interface Profile {
  id: string
  name: string
  email: string
  mobile: string
  city: string
  country: string
  image?: string
  bio?: string
  acceptedPrivacyPolicies?: boolean
  profileType?: ProfileType[]
  status?: string
  profileImage?: string
  interests?: string[]
}
